::ng-deep particle-add-column-dialog{width:100%}
/*# sourceMappingURL=add-column-dialog.component-QB674PIM.css.map */
